import _regeneratorRuntime from "@babel/runtime/regenerator";
var _jsxFileName = "/builds/ccm-innovation/ccm-2.0/address-components/src/components/StatePicker/StatePicker.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import _ from 'lodash';
import * as SettingsAPI from '../../utils/settings-api';
import defaultStates from '../../utils/default-states';
import './StatePicker.css';

var StatePicker = /*#__PURE__*/function (_Component) {
  _inheritsLoose(StatePicker, _Component);

  function StatePicker(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      fetchedStates: [],
      statesSorted: false
    };
    _this.config = {
      auth: {
        username: _this.props.muleClientId,
        password: _this.props.muleClientSecret
      },
      headers: {
        "access-control-allow-origin": "*"
      }
    };
    return _this;
  }

  var _proto = StatePicker.prototype;

  _proto.componentWillMount = /*#__PURE__*/function () {
    var _componentWillMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this2 = this;

      var _this$props, statesOverride, showFullStateNames, sortBy;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = this.props, statesOverride = _this$props.statesOverride, showFullStateNames = _this$props.showFullStateNames;
              sortBy = showFullStateNames ? ['name', 'abbr'] : ['abbr', 'name'];

              if (!statesOverride) {
                _context.next = 6;
                break;
              }

              this.setState({
                fetchedStates: _.sortBy(statesOverride, sortBy)
              });
              _context.next = 8;
              break;

            case 6:
              _context.next = 8;
              return SettingsAPI.fetchStateList(this.config, this.props.muleApiUrl, function (fetchedStates) {
                fetchedStates = _.sortBy(fetchedStates, sortBy);

                _this2.props.onStatesFetched(fetchedStates);

                _this2.setState({
                  fetchedStates: fetchedStates
                });
              }, function (error) {
                _this2.setState({
                  fetchedStates: defaultStates
                });

                console.log('error', error);
              });

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function componentWillMount() {
      return _componentWillMount.apply(this, arguments);
    }

    return componentWillMount;
  }();

  _proto.sortStates = function sortStates(states, sortByFullName) {
    var sortBy = sortByFullName ? ['name', 'abbr'] : ['abbr', 'name'];

    var sortedStates = _.sortBy(states, sortBy);

    return sortedStates;
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this3 = this;

    var _this$state = this.state,
        fetchedStates = _this$state.fetchedStates,
        statesSorted = _this$state.statesSorted;
    var showFullStateNames = this.props.showFullStateNames; // If states haven't been initially sorted OR the `showFullStateNames` prop has changed...

    if (!statesSorted || !prevProps.showFullStateNames === this.props.showFullStateNames) {
      this.setState({
        fetchedStates: this.sortStates(fetchedStates, showFullStateNames)
      }, function () {
        return _this3.setState({
          statesSorted: true
        });
      });
    }
  };

  _proto.renderAsterisk = function renderAsterisk(showRequiredAsterisk) {
    if (showRequiredAsterisk) {
      return /*#__PURE__*/React.createElement("span", {
        className: this.props.style.requiredAsterisk || 'required-asterisk',
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 77,
          columnNumber: 14
        }
      }, "*");
    }
  };

  _proto.render = function render() {
    var _this4 = this;

    var fetchedStates = this.state.fetchedStates;
    var _this$props2 = this.props,
        defaultOptionText = _this$props2.defaultOptionText,
        disabled = _this$props2.disabled,
        selectedState = _this$props2.selectedState,
        showFullStateNames = _this$props2.showFullStateNames,
        showRequiredAsterisk = _this$props2.showRequiredAsterisk,
        hideDefaultOption = _this$props2.hideDefaultOption;
    var _this$props$style = this.props.style,
        borderRadius = _this$props$style.borderRadius,
        generalInputStyle = _this$props$style.generalInputStyle,
        stateInputStyle = _this$props$style.stateInputStyle,
        titleStyle = _this$props$style.titleStyle;
    return /*#__PURE__*/React.createElement("div", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 102,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement("label", {
      className: "" + (titleStyle || ''),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 103,
        columnNumber: 9
      }
    }, "State", this.renderAsterisk(showRequiredAsterisk)), /*#__PURE__*/React.createElement("select", {
      type: 'select',
      name: 'state',
      autoComplete: 'none',
      className: "state-picker-input-field " + (borderRadius || 'border-radius') + " " + (generalInputStyle || '') + " " + (stateInputStyle || ''),
      style: selectedState === null ? {
        color: 'gray'
      } : {
        color: 'black'
      },
      disabled: disabled,
      value: selectedState === null ? 'State' : selectedState,
      onChange: function onChange(event) {
        return _this4.props.onStateSelected(event.target.value);
      },
      onBlur: function onBlur(event) {
        return _this4.props.onBlur(event.target.value);
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 104,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement("option", {
      value: "State",
      disabled: true,
      hidden: hideDefaultOption,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 115,
        columnNumber: 11
      }
    }, defaultOptionText), fetchedStates.map(function (state) {
      return /*#__PURE__*/React.createElement("option", {
        key: state.name,
        value: state.abbr,
        __self: _this4,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 119,
          columnNumber: 13
        }
      }, showFullStateNames ? state.name : state.abbr);
    })));
  };

  return StatePicker;
}(Component);

export { StatePicker as default };
StatePicker.defaultProps = {
  defaultOptionText: 'State',
  disabled: false,
  showFullStateNames: false,
  showRequiredAsterisk: false,
  hideDefaultOption: false,
  statesOverride: null,
  style: {
    borderRadius: 'border-radius',
    generalInputStyle: '',
    requiredAsterisk: '',
    stateInputStyle: '',
    titleStyle: ''
  },
  onBlur: function onBlur() {},
  onStatesFetched: function onStatesFetched() {}
};
StatePicker.propTypes = process.env.NODE_ENV !== "production" ? {
  // Required Props
  onStateSelected: PropTypes.func.isRequired,
  muleApiUrl: PropTypes.string.isRequired,
  muleClientId: PropTypes.string.isRequired,
  muleClientSecret: PropTypes.string.isRequired,
  // Optional Props
  defaultOptionText: PropTypes.string,
  disabled: PropTypes.bool,
  selectedState: PropTypes.string,
  showFullStateNames: PropTypes.bool,
  showRequiredAsterisk: PropTypes.bool,
  hideDefaultOption: PropTypes.bool,
  statesOverride: PropTypes.array,
  style: PropTypes.shape({}),
  onBlur: PropTypes.func,
  onStatesFetched: PropTypes.func
} : {};